import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import ListGroup from 'react-bootstrap/ListGroup';
import { Card, Col, Row, Spinner } from 'react-bootstrap';
import { ItemShow } from '../../components/form';
import toast from 'react-hot-toast';
import ImageSlider from '../../components/sliders';

const ReferenceShow = () => {
      const { referenceId } = useParams();

      const [loading, setLoading] = useState(false);
      const [reference, setReference] = useState([]);

      const loadData = async () => {
            setLoading(true);
            await axios
                  .get(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/references/${referenceId}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${JSON.parse(
                                          localStorage.getItem('token')
                                    )}`,
                                    'Content-Type': 'multipart/form-data'
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setReference(response.data.reference);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      useEffect(() => {
            loadData();
      }, []);

      return (
            <>
                  <Row>
                        <Col xs={12}>
                              <Card>
                                    <Card.Header>
                                          <Card.Title>
                                                Reference Detail
                                          </Card.Title>
                                          <Link
                                                to="/dashboard/references"
                                                className="btn btn-link"
                                          >
                                                Back
                                          </Link>
                                    </Card.Header>
                                    <Card.Body>
                                          {!loading ? (
                                                <Row>
                                                      <Col md={6}>
                                                            <Card>
                                                                  <Card.Body>
                                                                        <ListGroup>
                                                                              <ItemShow
                                                                                    title="Title"
                                                                                    value={
                                                                                          reference.title
                                                                                    }
                                                                              />
                                                                              <ItemShow
                                                                                    title="Category"
                                                                                    value={
                                                                                          reference.category
                                                                                    }
                                                                              />
                                                                              <ItemShow
                                                                                    title="User Name"
                                                                                    value={
                                                                                          reference.user_name
                                                                                    }
                                                                              />
                                                                              <ItemShow
                                                                                    title="Seo Title"
                                                                                    value={
                                                                                          reference.seo_title
                                                                                    }
                                                                              />
                                                                              <ItemShow
                                                                                    title="Seo Keyword"
                                                                                    value={
                                                                                          reference.seo_keyword
                                                                                    }
                                                                              />
                                                                              <ItemShow
                                                                                    title="Seo Description"
                                                                                    value={
                                                                                          reference.seo_description
                                                                                    }
                                                                              />

                                                                              <ItemShow
                                                                                    title="Status"
                                                                                    value={
                                                                                          reference.status ? (
                                                                                                <>
                                                                                                      <span className="text-success">
                                                                                                            Active
                                                                                                      </span>
                                                                                                </>
                                                                                          ) : (
                                                                                                <>
                                                                                                      <span className="text-warning">
                                                                                                            Disable
                                                                                                      </span>
                                                                                                </>
                                                                                          )
                                                                                    }
                                                                              />
                                                                        </ListGroup>
                                                                        <div className="mt-4">
                                                                              <div
                                                                                    dangerouslySetInnerHTML={{
                                                                                          __html: reference.description
                                                                                    }}
                                                                              ></div>
                                                                        </div>
                                                                  </Card.Body>
                                                            </Card>
                                                      </Col>
                                                      <Col md={6}>
                                                            <div>
                                                                  <ImageSlider
                                                                        image={
                                                                              reference.image
                                                                        }
                                                                        images={
                                                                              reference.images
                                                                        }
                                                                  />
                                                            </div>
                                                      </Col>
                                                </Row>
                                          ) : (
                                                <div className="text-center my-5">
                                                      <Spinner />
                                                </div>
                                          )}
                                    </Card.Body>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default ReferenceShow;
